import global from './global'
import auth from './auth'
import portal from './portal'
import elections from './elections'
import { createStore } from 'vuex'

const store = createStore({
  modules: {
    global,
    auth,
    portal,
    elections,
  },
})

export default store
